<template>
  <v-app>
    <auth-user-layout v-if="$store.state.auth.user" />
    <guest-layout v-else />
  </v-app>
</template>

<script>
  import GuestLayout from '@/views/layouts/GuestLayout.vue';
  import AuthUserLayout from '@/views/layouts/AuthUserLayout.vue';
  // import LoginSessionExpirationDialog from '@/components/LoginSessionExpirationDialog.vue';

  export default {
    name: 'App',
    components: {
      GuestLayout,
      AuthUserLayout,
      // LoginSessionExpirationDialog
    },
    data: () => ({
      //
    }),
    methods: {},
  };
</script>
